import React, { useState, useRef } from 'react';

import { useOutsideHandler } from 'src/common/hooks';

import FilterOptions from './FilterOptions';

const FilterButton: React.FC = () => {
  const menuRef = useRef(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleOnBlur = (): void => {
    setIsFilterOpen(false);
  };

  useOutsideHandler(menuRef, handleOnBlur);

  return (
    <div className="relative inline-block my-auto ml-4 text-left" ref={menuRef}>
      <button
        type="button"
        className="flex items-center"
        onClick={() => setIsFilterOpen(!isFilterOpen)}
      >
        <i className="icon-plus_icon text-base text-primary-1.0 font-semibold" />
        <p className="ml-1 text-base text-primary-1.0 font-semibold">Filter</p>
      </button>
      <FilterOptions isFilterOpen={isFilterOpen} />
    </div>
  );
};

export default FilterButton;
